import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../App.css';

function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu when route changes
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    // Prevent body scroll when mobile menu is open
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home with hash
      navigate(`/#${sectionId}`);
    } else {
      // Already on home page, update hash and scroll
      window.history.pushState(null, '', `#${sectionId}`);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const isTeamPage = location.pathname === '/team';

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            <img src="/img/logo2.png" alt="Esmé Hospitality Collective" />
          </Link>
          
          {/* Desktop Menu */}
          <ul className="nav-menu">
            <li>
              <Link 
                to="/#about"
                onClick={(e) => { scrollToSection('about', e); closeMobileMenu(); }}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/#services"
                onClick={(e) => { scrollToSection('services', e); closeMobileMenu(); }}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to="/#experience"
                onClick={(e) => { scrollToSection('experience', e); closeMobileMenu(); }}
              >
                Experience
              </Link>
            </li>
            <li>
              <Link 
                to="/team"
                className={isTeamPage ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Team
              </Link>
            </li>
            <li>
              <Link 
                to="/#contact"
                onClick={(e) => { scrollToSection('contact', e); closeMobileMenu(); }}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Hamburger Menu Button */}
          <button 
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      ></div>

      {/* Mobile Side Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <Link to="/" className="mobile-logo" onClick={closeMobileMenu}>
            <img src="/img/logo2.png" alt="Esmé Hospitality Collective" />
          </Link>
          <button className="mobile-menu-close" onClick={closeMobileMenu}>
            ×
          </button>
        </div>
        <ul className="mobile-nav-menu">
          <li>
            <Link 
              to="/#about"
              onClick={(e) => { scrollToSection('about', e); closeMobileMenu(); }}
            >
              About
            </Link>
          </li>
          <li>
            <Link 
              to="/#services"
              onClick={(e) => { scrollToSection('services', e); closeMobileMenu(); }}
            >
              Services
            </Link>
          </li>
          <li>
            <Link 
              to="/#experience"
              onClick={(e) => { scrollToSection('experience', e); closeMobileMenu(); }}
            >
              Experience
            </Link>
          </li>
          <li>
            <Link 
              to="/team"
              className={isTeamPage ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Team
            </Link>
          </li>
          <li>
            <Link 
              to="/#contact"
              onClick={(e) => { scrollToSection('contact', e); closeMobileMenu(); }}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Navigation;
